import { addContext, getContext, type ContextEntry } from '@/services/bot/context';
import logger from './logger';
import { expose } from './rpc';
import { useMoinBot } from './services/bot/botv2';
import { useThemeStore } from './store/theme';
import { useLayoutStore } from './store/layout';
import { useTeaserStore } from './store/teaser';
import { useWidgetStore } from './store/widget';

let isInitialized = false;
export const initiallizeApi = () => {
  if (isInitialized) return;

  isInitialized = true;
  const theme = useThemeStore();
  const bot = useMoinBot();
  const layout = useLayoutStore();
  const teaser = useTeaserStore();
  const store = useWidgetStore();

  const apiFuncs = {
    setFont() {
      theme.setCustomFont({
        fontfamily: 'Comic Sans MS',
        fontSizeBase: '162.5%',
        fontfaceCSS: '',
      });
    },
    addContext: (ctx: ContextEntry) => {
      addContext(ctx);
    },
    getContext: () => getContext(),
    toggle: () => {
      store.toggleWidget();
    },
    toggle_Widget: () => {
      store.toggleWidget();
    },
    close: () => {
      store.closeWidget();
    },
    open: () => {
      store.openWidget();
    },
    typing: () => {
      bot.setIsTyping(true);
    },
    alwaysOpen: () => {
      store.setWidgetOpenBehaviour('always');
      store.openWidget();
    },
    setThemeOption: (themeVars: Record<string, string>) => {
      theme.setThemeVariables(themeVars);
    },
    setWidgetzIndex: ({ index }: { index: number }) => {
      if (!index) return;
      layout.setZIndex(index);
    },
    showWidget() {
      store.setVisible(true);
    },
    hideWidget() {
      store.setVisible(false);
    },
    setPosition: ({ bottom, right, unit = 'px' }: { bottom: number | string, right: number | string, unit: string }) => {
      const error = () => {
        throw new Error('please no nullish');
      };
      if (unit === '%') {
        console.warn(
          'please use units like rem or em as realtive units, % is unfortunately not reliable due to technical issues',
        );
      }
      try {
        if (bottom === null || bottom === undefined || bottom === '') error();
        if (right === null || right === undefined || right === '') error();
        layout.setPosition(bottom + unit, right + unit);
      } catch {
        console.error('Please provide proper parameter for left, right and unit');
      }
    },
    initLivechat: async (/* { text = 'livechat Takeover' } */) => {

      logger.error('this api function has been deprecated');
      throw new Error('this api function was deprecated');
    },
    getLivechatAvailable: async (/* { text = 'livechat Takeover' } */) => {

      logger.error('this api function has been deprecated');
      throw new Error('this api function was deprecated');
    },
    startLivechat: async (/* { text = 'livechat Takeover' } */) => {

      logger.error('this api function has been deprecated');
      throw new Error('this api function was deprecated');
    },

    stopLivechat: async (/* { text = 'livechat Takeover' } */) => {

      logger.error('this api function has been deprecated');
      throw new Error('this api function was deprecated');
    },
    setAlignmentOrigin({ alignmentOrigin = 'bottom right' }) {
      layout.setAlignmentOrigin(alignmentOrigin);
    },
    teaser: ({
      /* showTeaser = true, */
      showAvatar = true,
      message = '',
      quickActions = [],
      timeout = 0,
      forceShow = false,
    }: {
      showAvatar?: boolean,
      message?: string,
      quickActions?: { text: string, intent: string }[],
      timeout?: number,
      forceShow?: boolean
    }) => {
      const qr = quickActions.map((intent) => {
        return {
          text: intent.text,
          intent: {
            name: intent.intent,
            parameters: {confidence: 1,},
          },
        };
      })
      teaser.setTeaser({
        /* showTeaser, */
        showAvatar,
        message,
        qr,
        timeout,
        forceShow,
      });
    },
    // text will be ignored
    sendIntent: ({ intent, confidence, rating }: { intent: string, confidence: number, rating?: number }) => {
      if (!intent) {
        console.error('invalid api call sendIntent: Intent is required');
        return;
      }
      bot.sendIntent(
        {
          intent: {
            name: intent,
            parameters: {
              confidence: confidence || 1.0,
              rating,
            },
          }
        },
        true,
      );
    },
    clearQR: () => {
      bot.clearQuickReplies();

    },
  }

  // EXPOSE ALL API FUNCIONS TO THE GLOBAL WINDOW OBJECT
  Object.keys(apiFuncs).forEach((key) => {
    // @ts-expect-error - we know that the key is a string
    expose(key, apiFuncs[key]);
  });


}

